// removed by extract-text-webpack-plugin
module.exports = {"message-center":"message-center","message-center-header":"message-center-header","searchbar":"searchbar","select-all":"select-all","message-center-body":"message-center-body","message-center-sidemenu":"message-center-sidemenu","message-center-table":"message-center-table","message-center-actions-wrapper":"message-center-actions-wrapper","message-center-actions":"message-center-actions"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/messageCenter/MessageCenter.scss
// module id = 5064
// module chunks = 1